export const countries: { [key: string]: string } = {
    'All': 'All',
    'UK&IRE': 'UK & Irish',
    'INT': 'International',
    'VR': 'Virtuals',
    'FR': 'France',
    'AE': 'UAE',
    'ZA': 'South Africa',
    'IN': 'India',
    'US': 'USA',
    'AU': 'Australia',
    'CL': 'Chile',
};
